import { cateringOrderClient } from '@/services/clients'

export default {
  checkHealth() {
    return cateringOrderClient.get('/health')
  },
}
